import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkTreeModule } from '@angular/cdk/tree';
import { RouterModule } from '@angular/router';
// Primeng modules
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { FullCalendarModule } from '@fullcalendar/angular';
import { TagModule } from 'primeng/tag';
import { StepsModule } from 'primeng/steps';
import { SharedModule } from '../shared/shared.module';
import { BlockableDivModule } from '../shared/components/blockable-div/blockable-div.module';
import { AccordionModule } from 'primeng/accordion';
import { PanelModule } from 'primeng/panel';
import { PinComponent } from './components/pin/pin.component';
import { SendCommandComponent } from './components/send-command/send-command.component';
import { PinPadComponent } from './components/pin-pad/pin-pad.component';

@NgModule({
    declarations: [
        PinComponent,
        SendCommandComponent,
        PinPadComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        RouterModule,
        ReactiveFormsModule,
        CdkTreeModule,
        BlockableDivModule,
        // primeng modules
        BlockUIModule,
        ButtonModule,
        InputTextModule,
        FormsModule,
        TabViewModule,
        TableModule,
        FullCalendarModule,
        TagModule,
        StepsModule,
        AccordionModule,
        PanelModule,
    ],
    exports: [
        PinComponent,
        SendCommandComponent,
        PinPadComponent,
    ]
})
export class AccessCompModule { }
